/* eslint-disable react/jsx-filename-extension */
import { ProfileOutlined } from '@ant-design/icons';
import React from 'react';
import CategoriaDePagos from 'views/Convenios/CategoriasDePagos';
import ConsultaDeConvenios from 'views/Convenios/ConsultaDeConvenios';
import PersonalDeConvenios from 'views/Convenios/PersonalDeConvenios';
import TiposDeConvenios from 'views/Convenios/TiposDeConvenios';

export default
{
  title: 'Convenios',
  icon: () => <ProfileOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Consulta de Convenios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ConsultaDeConvenios,
      permissionModel: 'convenio',
    },
    {
      title: 'Tipos de Convenios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeConvenios,
      permissionModel: 'tipodeconvenio',
    },
    {
      title: 'Categoria de Pagos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CategoriaDePagos,
      permissionModel: 'tipodeconvenio',
    },
    {
      title: 'Personal de Firma',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: PersonalDeConvenios,
      permissionModel: 'personaldeconvenio',
    },
  ],
};
